const brokerages = [
  "Ally Financial",
  "Charles Schwab",
  "Chase Bank",
  "Citibank",
  "E-Trade",
  "Fidelity Investments",
  "Firstrade Securities",
  "Interactive Brokers",
  "Lightspeed",
  "M1 Finance",
  "Merrill Edge",
  "PNC Financial",
  "Public.com",
  "Robinhood",
  "SoFi",
  "TD Ameritrade",
  "TradeStation",
  "U.S. Bancorp",
  "The Vanguard Group",
  "Webull",
  "Wells Fargo",
];

export default brokerages;
